// check environment, and get appropriate base API URL

const getApiBaseUrl = () => process.env.REACT_APP_API_BASE_URL;

export default getApiBaseUrl;
